exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style__tooltip___22Tmc{max-width:355px;opacity:1 !important;z-index:9999999;border-radius:3px;box-shadow:0 0 20px 0 rgba(0,0,0,0.2)}\n", ""]);

// Exports
exports.locals = {
	"tooltip": "style__tooltip___22Tmc"
};